/**
 * Money formatter — emits a localised, symbol-prefixed amount string.
 * Replaces the old "1,200 NXC" convention. Default currency is INR (₹).
 *
 * Trip groups may set group.currency to USD/EUR/GBP/AED/SGD/AUD/CAD/JPY —
 * callers pass that currency through and the right symbol is prefixed.
 * The minus sign is U+2212 (mathematical minus) to match the rest of the UI.
 *
 *   formatNXC(1200)            -> "₹1,200"
 *   formatNXC(-1918)           -> "−₹1,918"
 *   formatNXC(0)               -> "₹0"
 *   formatNXC(null)            -> "₹0"
 *   formatNXC(450, 'EUR')      -> "€450"
 *   formatNXC(-1200, 'USD')    -> "−$1,200"
 *
 * The function name is kept as `formatNXC` so the 18+ existing import
 * sites don't need to change. A new `formatMoney` alias is exported for
 * clarity in new code.
 */

export const CURRENCY_SYMBOLS = {
  INR: '₹', USD: '$', EUR: '€', GBP: '£', AED: 'د.إ',
  SGD: 'S$', AUD: 'A$', CAD: 'C$', JPY: '¥',
};

export function currencySymbol(code) {
  return CURRENCY_SYMBOLS[(code || 'INR').toUpperCase()] || '₹';
}

export function formatNXC(amount, currency = 'INR') {
  const n = Math.round(Number(amount) || 0);
  const abs = Math.abs(n).toLocaleString('en-IN');
  const sym = currencySymbol(currency);
  return n < 0 ? `−${sym}${abs}` : `${sym}${abs}`;
}

export const formatMoney = formatNXC;

// iter234 — Group coin formatter. When the group has a custom coin name
// ("Pickle Points"), coin-denominated amounts show "1,200 Pickle Points";
// default ("Coins" / unset) keeps the classic ₹ display.
export function formatCoins(amount, coinName) {
  if (!coinName || coinName === 'Coins') return formatNXC(amount);
  const n = Math.round(Number(amount) || 0);
  const abs = Math.abs(n).toLocaleString('en-IN');
  return n < 0 ? `−${abs} ${coinName}` : `${abs} ${coinName}`;
}

export default formatNXC;
